import { _TabEnabledMixin } from "../../../moreCore/_loadingHelpers/Tabbing";
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './contactDisplayTable.html?raw';
import on from 'dojo/on';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';

import communicationDisplayTable from './communicationDisplayTable';
import "./communicationDisplayTable";

import contactEditor from './contactEditor';

import { TelecommunicationTypes, CommunicationTypes } from "./conComTypes";
import { AddressTypes } from "../../_loadingHelpers/Address";
import emailForm from '../../EMail/emailForm';
import { AddressClassnames, AddressWizardTypes } from "../AddressWizardTypes";
import { DateHelpers, ExtraHelpers, HtmlHelpers } from "../../../more/Helpers";

class contactDisplayTable extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private contactTable: MdsLax<InstanceType<typeof StaticTable>>;
    private telecomContainer: HTMLDivElement;
    private addNewFloatingMenu: MdsLax<InstanceType<typeof FloatingMenu>>;
    private communicationTableContainer: HTMLDivElement;
    private addressRefID: string;

    private flagContactTableIsReady = false;
    private flagFirstLoadIsReady = false;

    private masterTableDivContainer: HTMLDivElement;
    private contactRegestry: Array<{ ID: string, ClassPrintname: string, Classname: string, telecom_code: string, ModificationDate: string | any }> = [];
    private communicationTableWidget: MdsLax<InstanceType<typeof communicationDisplayTable>>;

    private editWidgetRegestry: Record<string,{editWidget:MdsLax<InstanceType<typeof contactEditor>>, entity:any, ID:string}> = {};

    private toDeleteList: Array<string> = []; //geloeschte IDs werden hier gespeichert

    private flagReRenderingInProgress = false;
    private newCounter: number = 0; //zum erstellen von einzigartigen IDs von neuen elementen
    private readonly newIdPreFix = "NEW_"; //intern werden ID's mit diesen prefix erstellt und neue entrys werden anhand von dem auch erkannt.

    private country: AddressTypes.Country;
    private defaultCountryISO2: string;

    private addNewBtnElem:HTMLButtonElement;
    public flagUseCommunicationTable = true;

    //definition von klassen, icons usw. "fallback" wird verwendet wenn eine klasse nicht bekannt ist
    public readonly contactStaticData: Record<string, { icon: string, inputType: string, floatLabel: string, floatGroupName: string, floatCallback: Function, addressWizardKey: string }> = { //wird eh vom webpack compressed, oder?
        "email_addresses": {
            icon: "fas fa-envelope-open-text",
            inputType: 'text',
            floatLabel: (this as any).translations["AddressWizard__mail"],
            floatGroupName: "contact",
            //die callbacks sind in dem record, damit wir spaeter aus dem communication table ein korrektes callback mitgeben koennen....
            floatCallback: lang.hitch(this, (this as any)._onHandle_FloatingMenuClick, "email_addresses"),
            addressWizardKey: "mail"
        },
        "fax_addresses": {
            icon: "fas fa-fax",
            inputType: 'tel',
            floatLabel: (this as any).translations["AddressWizard__fax"],
            floatGroupName: "contact",
            floatCallback: lang.hitch(this, (this as any)._onHandle_FloatingMenuClick, "fax_addresses"),
            addressWizardKey: "fax"
        },
        "phone_numbers": {
            icon: "fas fa-phone-alt",
            inputType: 'tel',
            floatLabel: (this as any).translations["AddressWizard__phone"],
            floatGroupName: "contact",
            floatCallback: lang.hitch(this, (this as any)._onHandle_FloatingMenuClick, "phone_numbers"),
            addressWizardKey: "phone"
        },
        "messenger_addresses": {
            icon: "fas fa-sms",
            inputType: 'text',
            floatLabel: (this as any).translations["AddressWizard__messenger"],
            floatGroupName: "contact",
            floatCallback: lang.hitch(this, (this as any)._onHandle_FloatingMenuClick, "messenger_addresses"),
            addressWizardKey: "messenger"
        },
        "mobilephone_numbers": {
            icon: "fas fa-mobile-alt",
            inputType: 'tel',
            floatLabel: (this as any).translations["AddressWizard__mobile"],
            floatGroupName: "contact",
            floatCallback: lang.hitch(this, (this as any)._onHandle_FloatingMenuClick, "mobilephone_numbers"),
            addressWizardKey: "mobile"
        },
        "web_addresses": {
            icon: "fas fa-globe",
            inputType: 'url',
            floatLabel: (this as any).translations["AddressWizard__web"],
            floatGroupName: "contact",
            floatCallback: lang.hitch(this, (this as any)._onHandle_FloatingMenuClick, "web_addresses"),
            addressWizardKey: "web"
        },
        "webphone_addresses": {
            icon: "fas fa-headset",
            inputType: 'text',
            floatLabel: (this as any).translations["AddressWizard__webphone"],
            floatGroupName: "contact",
            floatCallback: lang.hitch(this, (this as any)._onHandle_FloatingMenuClick, "webphone_addresses"),
            addressWizardKey: "webphone"
        },
        "fallback": {
            icon: "far fa-id-badge",
            inputType: 'text',
            floatLabel: (this as any).translations["General_Unknown_Element"],
            floatGroupName: "contact",
            floatCallback: null,
            addressWizardKey: null
        },
    }

    public hasEntries(): boolean {
        //return this.contactRegestry?.length != 0; // wahrscheinlich nicht ausreichend, aber ohne Entitystore wieder händisch drüm kümmern? fix ned.
        let hasEntries: boolean = this.contactTable.getRowCount() != 0;
        if (!hasEntries && this.communicationTableWidget) {
            hasEntries = this.communicationTableWidget.hasEntries();
        }

        return hasEntries;
    }

    public getContactRegestry() :Array<any>{

        return this.contactRegestry;
    }
    public updateAddressWizzardState(state: { [key: string]: Array<{ [key: string]: any }> }) {
        //neue entitys hinzufuegen
        for (let entry of this.contactRegestry) {
            //wir suchen als erstes den key fuer das passende objekt raus
            let targetValueMap = null;
            for (const key in this.contactStaticData) {
                if (key == entry.Classname) {
                    targetValueMap = this.contactStaticData[key].addressWizardKey;
                }
            }
            if (targetValueMap != null) {
                if (state.hasOwnProperty(targetValueMap) == false) {
                    state[targetValueMap] = [];//wenn es die kategorie nicht gibt, erzeugen wir diese
                }
                //wenn felder bereits vorhanden sind schauen wir ob das entry bereits forhanden ist, wenn ja update und ansonsten hinzufuegen
                let currentEntryFieldName = targetValueMap + "_" + entry.ID;
                let wasFound = false;
                for (let wizEntry of state[targetValueMap]) {
                    if (wizEntry.hasOwnProperty("fieldName")) {
                        if (wizEntry["fieldName"] == currentEntryFieldName) {
                            //feld ist vorhanden und wird geupdated
                            wizEntry["value"] = entry.telecom_code;
                            wasFound = true;
                        }
                    }
                }
                if (wasFound == false) { //wenn es den eintrag nicht gib, fuegen wir den einfach hinzu
                    if (entry.ID.indexOf(this.newIdPreFix) == -1) {
                        //wenn das entry nicht neu ist hauen wir einfach die ID hinzu, auch wenn dieser fall eigentlich nicht auftretten sollte...
                        state[targetValueMap].push({
                            fieldName: currentEntryFieldName,
                            value: entry.telecom_code,
                            ID: entry.ID
                        });
                    } else {
                        state[targetValueMap].push({
                            fieldName: currentEntryFieldName,
                            value: entry.telecom_code,
                        });
                    }
                }
            } else {
                console.warn("unable to find addressWizardKey for entry", entry);
            }
        }
        //geloeschte IDs rausnehmen
        let wizKeys = [];
        for (const key of Object.keys(this.contactStaticData)) {
            if (this.contactStaticData.hasOwnProperty(key)) {
                if ('addressWizardKey' in this.contactStaticData[key]) {
                    if ((typeof this.contactStaticData[key].addressWizardKey != 'undefined') && (this.contactStaticData[key].addressWizardKey != null)) {
                        wizKeys.push(this.contactStaticData[key].addressWizardKey);
                    }
                }
            }
        }
        for (const key of Object.keys(state)) {
            if (state.hasOwnProperty(key)) {
                if (wizKeys.indexOf(key) != -1) { //key ist auch ein wizKey
                    //jetzt schauen wir ob die value ein array ist
                    if (Array.isArray(state[key])) {
                        //wenn ja gehen wir alle durch
                        state[key] = state[key].filter(entry => {
                            // Filter, wenn element kein ID feld hat, immer includen (return true)
                            // wenn ID feld -> ist ID feld in delete list? ja,false ansonsten true
                            if (entry.hasOwnProperty("ID")) {
                                if (this.toDeleteList.indexOf(entry["ID"]) != -1) {
                                    return false;
                                }
                            }
                            return true;
                        });
                    }
                }
            }
        }
        return state;
    }

    public updateCountry(country: AddressTypes.Country) {
        this.country = country;
    }

    public setAddressContext(addressID: string, country?: AddressTypes.Country) {
        if (country) this.country = country;
        if (addressID && addressID != this.addressRefID) {
            this.addressRefID = addressID;

            this._loadCommunicationsTable();

            if ((this.flagContactTableIsReady == true)) {
                this.loadData();
                return;
            }
            this.flagFirstLoadIsReady = true;
        }
    }

    private _loadCommunicationsTable() {
        if (this.hasFeature("Address/CommunicationsList")) {
            // das widget wird halt im template schon instanziert und ist auch da, wenn es das feature nicht gibt
            // + im postcreate fetcht es sofort ein Tablelayout
            // sollte eigentlich raus in den addresswizard und erst instanziert und platziert werden, wenn feature vorhanden

            let setupParams: Array<CommunicationTypes.FilterParams> = [
                {
                    descriptor: "vt_addresses",
                    value: this.addressRefID
                }
            ];

            this.communicationTableWidget.on("contentChange", lang.hitch(this, this.emit, "contentChange"));

            this.communicationTableWidget.setup(null, setupParams);


            //this.communicationTableWidget.setContext([
            //        {
            //            Classname: "vt_addresses",
            //            ID: this.addressRefID
            //        }]
            //);
            if (this.communicationTableContainer) {
                this.hideNode(this.communicationTableContainer, false);
            }
        }
    }

    postCreate(): void {
        this.contactTable = new StaticTable();
        this.contactTable.on("tableDrawn", lang.hitch(this, this.emit, "contentChange"));
        this.contactTable.placeAt(this.telecomContainer);
        this.contactTable.setHeadingLabelFormatter(lang.hitch(this, this._tableFormatter_heading));
        this.contactTable.setFormatter(lang.hitch(this, this._tableFormatter_cells));
        this.contactTable.setCyAttribute("contactDisplay");
        this.communicationTableWidget.on("requestEditor", lang.hitch(this, (widgetObj: any) => {
            this.emit("requestCommunicationEditor", widgetObj);
        }));
        ExtraHelpers.sideLoadResource(
            window.appRoot + "Content/intertelinput/intlTelInput.js", 'js'
        ).then(()=>{
            this.RequestManager.callfunction(
                "Webtool_API_AddressWizard__GetTelecomTableLayout",
                "",
                lang.hitch(this, this._onCallback_GetTelecomTableLayout),
                lang.hitch(this, (err) => {
                    console.error("unable to fetch telecom table data", err);
                    this.showToast((err as more.requestErrorMessage).Message, "far fa-dizzy");
                })
            );
        });

        let module = this.getModule("Address");
        if (module) {
            module["defaultCountryISO2"] ? this.defaultCountryISO2 = module["defaultCountryISO2"] : this.defaultCountryISO2 = null;
        }
    }

    private _tableFormatter_heading(displayName: string, propertyName: string) {
        if (propertyName == "ClassPrintname") {
            if (!displayName) {
                return this.translations["General_Label_Type"];
            }
            return false;
        }
        return false;
    }

    private _tableFormatter_cells(cell: StaticTable.StaticTableCell<AddressWizardTypes.Telecommunication>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        let targetClassType = entity.Classname;
        let targetID = entity.ID

        switch (colName) {
            case 'ClassPrintname':
                let parentDiv = document.createElement('span');
                let targetIcon = this.contactStaticData["fallback"].icon;

                if (targetClassType in this.contactStaticData) {
                    targetIcon = this.contactStaticData[targetClassType].icon
                }

                HtmlHelpers.createFontawesomeIcon(targetIcon, "right", node, "first");
                return false;
                break;
            case 'ModificationDate':
                let dateLabel = document.createElement('span');

                //dateLabel.style.fontStyle = "italic";
                let displayValue = "";
                if ((cell.value != "") && (typeof cell.value != 'undefined') && (cell.value != null)) {
                    let d = new Date(cell.value * 1000);
                    DateHelpers.dateTimeToString(d);
                    //displayValue = d.toLocaleString();
                }
                if (targetID.indexOf(this.newIdPreFix) != -1){ //wenn element neu ist, setzen wir einfach das jetzige datum als neu erstell
                    //neues element
                    displayValue = "";
                }
                node.innerHTML = displayValue;
                return true;
                break;
            case 'telecom_code':
                if ((cell.value == "") || (cell.value == null) || (typeof cell.value == 'undefined')) {
                    cell.value = ""; //default formatter ist gemein zu mir

                }
                
                let newEditWidget = new contactEditor(
                    targetClassType,
                    cell.value,
                    this.contactStaticData[targetClassType].inputType,
                    targetID,
                    this.country ? this.country.lc_iso_alpha_2 as any : this.defaultCountryISO2);
                newEditWidget.on("changed", lang.hitch(this, this._onChanged_Editor));
                this.editWidgetRegestry[targetID] = {
                    ID: targetID,
                    entity: cell.entity,
                    editWidget:newEditWidget,
                };
                this.editWidgetRegestry[targetID].editWidget.placeAt(cell.contentnode);
                this.editWidgetRegestry[targetID].editWidget.on("dirty", lang.hitch(this, (dirtyState:boolean)=>{
                    this.emit("dirty", dirtyState);
                    this.emitDirty(dirtyState);
                }));
                this.editWidgetRegestry[targetID].editWidget.on("countryDropDown", lang.hitch(this, this._onHandle_TeleCountryDropDownOpen));
                return true;
            default:
                break;
        }
        return false;
    }

    private _onHandle_TeleCountryDropDownOpen(dropDownState){
        //wird getriggered wenn das popup zur auswahl von countrys offen ist/geschloessen wird
        if (dropDownState){
            this.telecomContainer.classList.add("staticTableForceDisableOverflow");
        }else{
            this.telecomContainer.classList.remove("staticTableForceDisableOverflow");
        }
    }

    private _onChanged_Editor(widget:MdsLax<InstanceType<typeof contactEditor>>){
        let targetID = widget.getID();
        let newValue = widget.getValue();
        //dadurch das die value schon im """DOM""" ist, muessen wir nur die daten aktualisieren
        for (let entry of this.contactRegestry){
            if (entry.ID == targetID){
                entry.telecom_code = newValue;
            }
        }
    }

    private _onCallback_GetTelecomTableLayout(layoutData: any) {
        this.contactTable.setLayout(layoutData[0]);
        if ((this.flagFirstLoadIsReady == true)) {
            this.loadData();
            return;
        }
        this.flagContactTableIsReady = true;
    }

    public updateData() {
        this.loadData();
    }

    private loadData() {
        if (!this.addressRefID) {
            //console.warn("can't load data if the entry is not saved yet");
            return;
        }
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard__GetTelecomTableData",
            { addrRefID: this.addressRefID },
            lang.hitch(this, this._onCallback_LoadTableData),
            lang.hitch((err) => {
                console.error("unable to retrieve contact display data", err);
                this.showToast((err as more.requestErrorMessage).Message, toasterIcons.error);
            })
        );

        this._loadCommunicationsTable();
    }
    private _onCallback_LoadTableData(resultData: { contactData: Array<{ ID: string, ClassPrintname: string, telecom_code: string, ModificationDate: string }> }) {
        //wir hauen alles in ein array damit wir dieses sortieren koennen
        let contactList: Array<{ ID: string, ClassPrintname: string, telecom_code: string, ModificationDate: string }> = [];
        for (let contactObj of resultData.contactData) {
            contactList.push(contactObj);
        }

        contactList.sort(lang.hitch(this, this._onCompare_SortEntitysFunction));

        //dates in unix timestamps
        for (let entry of contactList){
            entry.ModificationDate = String(Math.floor(new Date(entry.ModificationDate).getTime() / 1000));
        }

        this.contactRegestry = contactList as any;

        this.render_table();
    }

    private render_table() {
        let oldMinHeight = this.masterTableDivContainer.style.minHeight;
        this.masterTableDivContainer.style.minHeight = window.getComputedStyle(this.masterTableDivContainer).height; //freeze min-height damit der scroll nicht so rumspringt

        this.contactTable.setData([]);
        //wir destroyen alle widgets und dann reseten wir die regestry
        for (let key in this.editWidgetRegestry){
            try{
                this.editWidgetRegestry[key].editWidget.destroyRecursive();
            }catch(err){
                console.warn("can't destroy edit widget, might leak memory", err);
            }
        }
        this.editWidgetRegestry = {}; //reset, wird vom table formatter befuellt

        this.contactTable.addDefaultRowActionButton('delete', lang.hitch(this, this._onAction_DeleteEntry), null, false);
        this.contactTable.enableActionButton('delete', null, true, 'current');

        if (this.hasFeature("Email/Addresswizard_ButtonOnContactsTable") && this.hasUserRole("Email_Editor")) {
            this.contactTable.addCustomRowActionButton("email",
                lang.hitch(this, this._onAction_CreateEmail),
                "fas fa-envelope-open-text",
                null,
                500,
                null,
                lang.hitch(this, this._onCheck_EmailActionAvailable),
                true);
        }
        this.contactTable.setData(this.contactRegestry);
        this.masterTableDivContainer.style.minHeight = oldMinHeight; //un-freeze
    }

    private _onCheck_EmailActionAvailable(data: AddressTypes.TelecommunicationEntity) {
        if (data.Classname == AddressClassnames.email_addresses) {
            // Feature und Rolle haben wir schon geprüft!
            return true;
        }
        return false;
    }

    private _onAction_CreateEmail(data: StaticTable.StaticTableRowGroup<AddressTypes.TelecommunicationEntity>) {
        if (this.hasFeature("Email/Addresswizard_ButtonOnContactsTable") && this.hasUserRole("Email_Editor")) {

            let entity = data.entity;

            let form = new emailForm();
            form.setup(null, { isHistoryContext: true, contextEntity: { Classname: AddressClassnames.vt_addresses, ID: this.addressRefID }, contextName: "contactTable" });
            form.show("dlg", null, this.getTabContainerName());

            on(form, "saved", lang.hitch(this, this._loadCommunicationsTable));

            form.addRecipients("to", [{ entityID: entity.ID, mailaddress: entity.telecom_code }]);
        }
    }

    private _onAction_DeleteEntry(action: any) {
        let targetID = action["entity"]["ID"];
        this.contactRegestry = this.contactRegestry.filter((entry) => {
            return entry["ID"] != targetID;
        });
        this.toDeleteList.push(targetID);
        this.emit("dirty", true);
        this.render_table(); //widget wird im table destroyed...
    }

    private _onCompare_SortEntitysFunction(a: any, b: any) {
        //wir sortieren zuerst nach typ (deshalb Printname), dann nach Modification date (zuletzt geandert sollte weiter oben sein) und dann nach ID als fallback
       if (a.hasOwnProperty("ClassPrintname") && b.hasOwnProperty("ClassPrintname")) {
            if (a["ClassPrintname"] < b["ClassPrintname"]) {
                return -1;
            }
            if (a["ClassPrintname"] > b["ClassPrintname"]) {
                return 1;
            }
        }
        if (a.hasOwnProperty("ModificationDate") && b.hasOwnProperty("ModificationDate")) {
            if (a["ModificationDate"] < b["ModificationDate"]) {
                return -1;
            }
            if (a["ModificationDate"] > b["ModificationDate"]) {
                return 1;
            }
        }

        if (a.hasOwnProperty("ID") && b.hasOwnProperty("ID")) {
            if (a["ID"] < b["ID"]) {
                return -1;
            }
            if (a["ID"] > b["ID"]) {
                return 1;
            }
        }

        return 0;
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public getFloatEntrys() {
        let entrys: Array<{ callback: Function, icon: string, groupname: string, label: string }> = [
        ];

        for (const key in this.contactStaticData) {
            if (key != 'fallback') {
                if (this.contactStaticData.hasOwnProperty(key)) {
                    let cb: Function | null = null;
                    if (this.hasUserRole("Addresses_Edit")) {
                        cb = this.contactStaticData[key].floatCallback
                    }
                    entrys.push({
                        callback: cb,
                        icon: this.contactStaticData[key].icon,
                        groupname: this.contactStaticData[key].floatGroupName,
                        label: this.contactStaticData[key].floatLabel,
                    });
                }
            }
        }
        return entrys;
    }

    private _onClick_NewCom(ev: Event) {
        let entrys = this.getFloatEntrys();

        if (this.flagUseCommunicationTable == true) {
            entrys = entrys.concat(this.communicationTableWidget.getFloatEntrys());
        }

        this.addNewFloatingMenu = new FloatingMenu();
        //this.addNewFloatingMenu.addGroup("contact", this.translations["AddressWizard__ContactDataField_title_contactData"], "far fa-address-card");
        //this.addNewFloatingMenu.addGroup("communications", this.translations["AddressWizard__ContactDataField_title_comObj"], "far fa-comment-alt");
        this.addNewFloatingMenu.open(ev,
            entrys,
            this.translations["AddressWizard__ConComTable_AddNew_Header"],
        );
    }

    private newItemDisplayDataCache: Record<string, { classname: string, printname: string }> = {};


    addTelecomEntry_Remote(type: string, telecom_code: string) {
        if (this.contactRegestry.filter(x => x.telecom_code == telecom_code).length == 0)
            this._onHandle_FloatingMenuClick(type, telecom_code);
    }

    private async _onHandle_FloatingMenuClick(clicked: string, predefinedTelecom: string = null) {
        if (!(clicked in this.contactStaticData)) {
            console.error("unknown option was selected from floating menu, feature not implemented fully", clicked);
            return;
        }

        if (!(clicked in this.newItemDisplayDataCache)) {
            this.StandbyStart(this.addNewBtnElem);
            this.addNewBtnElem.classList.add("w3-disabled");
            await this.RequestManager.callfunction( //wir holen uns mit einer request alle printnames zu allen kontakt objekte raus
                "Webtool_API_AddressWizard__GetTelecomClasses",
                {},
                lang.hitch(this, this.addNewEntryToTable),
                lang.hitch(this, (err) => {
                    console.error("error fetching display data", err);
                    this.showToast((err as more.requestErrorMessage).Message, "far fa-dizzy");
                })
            );
            this.StandbyStop();
            this.addNewBtnElem.classList.remove("w3-disabled");
            return this._onHandle_FloatingMenuClick(clicked, predefinedTelecom);
        }
        let entry = this.newItemDisplayDataCache[clicked];
        let madeUpId = this.newIdPreFix + this.newCounter;
        this.newCounter++;
        if (typeof predefinedTelecom == 'object'){ // weil [object Object] net so schnoen is
            predefinedTelecom = null;
        }
        this.contactRegestry.push({
            //$ClassPrintname: entry.printname,
            ClassPrintname: entry.printname,
            Classname: entry.classname,
            ID: madeUpId,
            ModificationDate: new Date().valueOf(),
            telecom_code: predefinedTelecom ? predefinedTelecom : "",
        });
        //neues feld anzeigen und als editor oeffnen
        this.render_table();
        //wir setzen focus auf das neue entry
        this.editWidgetRegestry[madeUpId].editWidget.focus();
    }

    private addNewEntryToTable(res: { resultList: Array<{ classname: string, printname: string }> }) {
        //zum cache hinzufuegen
        for (let entry of res.resultList) {
            this.newItemDisplayDataCache[entry.classname] = entry;
        }
    }

}

mdsLazyProto(contactDisplayTable.prototype, {
  addNewFloatingMenu: () => (new FloatingMenu()),
});
export default mdsWidget(contactDisplayTable);
